/**
 * 这个函数的作用就是，简化根据stat.code判断是否成功的逻辑，不需要在多个页面写大量if else
 * @param res          后台返回的原始res数据
 * @returns {Promise}
 */
export const responseHandler = res => {
  let originData = res.data || {};
  if (originData.hasOwnProperty('data') && originData.hasOwnProperty('isError')) {
    // 格式1：{ isError: false, code: 0, data: <any> }
    return new Promise((resolve, reject) => {
      if (originData.isError === false) {
        resolve(originData.data);
      } else {
        reject(originData);
      }
    });
  } else if (originData.hasOwnProperty('result') && originData.hasOwnProperty('data')) {
    // 格式2：{ result: ok, data: <any> }
    return new Promise((resolve, reject) => {
      if (originData.result === 'ok') {
        resolve(originData.data);
      } else {
        reject(originData.result); //只返回相关的错误信息部分
      }
    });
  }
};
